import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { BONUSES, PRICE } from '../constants/content';
import { PriceDisplay } from './PriceDisplay';
export function BonusSection() {
  return <section className="w-full bg-ink py-14 text-white sm:py-20" data-id="element-17" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-3xl px-4" data-id="element-18" data-mp="1yf30bwm9v8hk">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-12 text-center" data-id="element-19" data-mp="1yc72e8afcjt4">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border-2 border-gold bg-gold/10 px-4 py-1.5 text-sm font-700 uppercase tracking-widest text-gold-light" data-id="element-20" data-mp="1eozn889gjadz">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="mzefpbwhqljx" />
            Bonos exclusivos
          </div>
          <h2 className="font-display text-3xl font-700 leading-tight sm:text-5xl" data-id="element-22" data-mp="29suyurlvzr2i">
            Reclamá Estos 8 Bonos Exclusivos Si Comprás Hoy
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-gray-300" data-id="element-23" data-mp="2eotg7v8ss8tf">
            Si entrás hoy, te llevás 8 bonos especiales por tiempo limitado que
            te van a hacer arrancar mucho más rápido…
          </p>
        </motion.div>

        {/* Vertical bonus stack */}
        <div className="space-y-6" data-id="element-24" data-mp="1qv1vjo7cpf4l">
          {BONUSES.map((b, i) => <motion.article key={b.n} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.05
        }} className="flex flex-col gap-5 rounded-2xl border-2 border-gold bg-gradient-to-b from-white to-cream p-5 text-ink shadow-[0_0_40px_-12px_rgba(200,150,30,0.5)] sm:flex-row sm:items-center sm:p-6" data-id="element-25" data-mp="1vtd3fte35fk6" data-mpi={i}>
              <div className="relative shrink-0 self-center" data-id="element-26" data-mp="1q4ljq0ixwnzy">
                {b.imgSet ? <picture data-id="element-27" data-mp="1m1ypjsysqqzl">
                    <source type="image/webp" srcSet={`${b.imgSet.webp400} 400w, ${b.imgSet.webp700} 700w`} sizes="(max-width: 640px) 100vw, 700px" data-id="element-28" data-mp="1m3tb99hw6n4q" />
                    <img src={b.imgSet.jpg700} srcSet={`${b.imgSet.jpg400} 400w, ${b.imgSet.jpg700} 700w`} sizes="(max-width: 640px) 100vw, 700px" alt={b.title} width={128} height={128} loading="lazy" decoding="async" className="h-32 w-32 rounded-xl object-cover ring-4 ring-gold/40 sm:h-28 sm:w-28" data-id="element-29" data-mp="tbzu9fu0dxmh" />
                  </picture> : <img src={b.img} alt={b.title} width={128} height={128} loading="lazy" decoding="async" onError={e => {
              const img = e.currentTarget;
              // Fallback to a verified poultry photo so no broken image shows.
              if (!img.dataset.fallback) {
                img.dataset.fallback = 'true';
                img.src = 'https://images.unsplash.com/photo-1604503468506-a8da13d82791?auto=format&fit=crop&w=256&q=70&fm=webp';
              }
            }} className="h-32 w-32 rounded-xl object-cover ring-4 ring-gold/40 sm:h-28 sm:w-28" data-id="element-30" data-mp="5bo2x1ogm7pb" />}
                <span className="absolute -left-3 -top-3 flex h-10 w-10 items-center justify-center rounded-full bg-crimson font-display text-lg font-700 text-white shadow-md" data-id="element-31" data-mp="3f7wqtjc4hked">
                  #{b.n}
                </span>
              </div>
              <div className="flex-1 text-center sm:text-left" data-id="element-32" data-mp="35iv8vnm0osxr">
                <span className="text-xs font-700 uppercase tracking-widest text-gold-dark" data-id="element-33" data-mp="30jscerk3rv1e">
                  Bono #{b.n}
                </span>
                <h3 className="mb-1 font-display text-xl font-600 sm:text-2xl" data-id="element-34" data-mp="20v8oumpdrup">
                  {b.title}
                </h3>
                <p className="mb-3 text-sm leading-relaxed text-gray-700" data-id="element-35" data-mp="3o8ushuz39fts">
                  {b.desc}
                </p>
                <div className="inline-flex items-center gap-2 rounded-lg bg-green-100 px-3 py-1.5 text-sm font-700 text-green-800" data-id="element-36" data-mp="3ja9w66myjgam">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="2cv97mm09i0e2" />
                  Valor Regular:{' '}
                  <PriceDisplay amount={b.value} strike className="text-green-700" data-id="element-38" data-mp="27ta1j4d50pdf" />
                  <span data-id="element-39" data-mp="savr1obabexm">— GRATIS para vos</span>
                </div>
              </div>
            </motion.article>)}
        </div>

        {/* Total value box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-10 rounded-2xl border-4 border-gold bg-crimson-dark p-6 text-center shadow-xl sm:p-8" data-id="element-40" data-mp="1216t15bere1v">
          <p className="text-sm font-600 uppercase tracking-widest text-gold-light" data-id="element-41" data-mp="1kz9mpxewhz60">
            Valor total de todo el paquete
          </p>
          <div className="mt-2 flex flex-col items-center justify-center gap-1" data-id="element-42" data-mp="3hupcukl978re">
            <PriceDisplay amount={PRICE.totalValue} strike className="font-display text-3xl font-600 text-gray-300 sm:text-4xl" data-id="element-43" data-mp="3ms7io23z57v6" />
            <span className="text-base font-600 text-white" data-id="element-44" data-mp="3aqprz7264p6p">
              Hoy, tu inversión es solo de
            </span>
            <PriceDisplay amount={PRICE.today} className="font-display text-5xl font-700 text-gold-light sm:text-6xl" symbolClassName="mr-0.5 align-top text-3xl" data-id="element-45" data-mp="3oqgzcoy6j7bq" />
          </div>
        </motion.div>
      </div>
    </section>;
}